module.exports = __webpack_public_path__ + "static/media/bridge.9f74eac5.svg";